import { useTranslation } from 'react-i18next';
import Table from 'react-bootstrap/Table';

export const SoonExpiredContractsTable = ({ contracts }) => {
    const { t } = useTranslation('partner');

    return (
        <div className={'expired-contracts-container'}>
            {contracts != null && contracts.length > 0
                ? <div>
                    <h4 className={'center'}>{t('homePage:expiredContracts')}</h4>
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>{t('partnerName')}</th>
                            <th>{t('contracts.number')}</th>
                            <th>{t('contracts.validTill')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {contracts.map((contract, index) => {
                            return (
                                <tr key={index}>
                                    <td key={'partnerName' + index}>{contract.partnerTitle}</td>
                                    <td key={'number' + index}>{contract.code}</td>
                                    <td key={'validTill' + index}>{contract.validTill}</td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </Table>
                </div>
                : <div>
                    <h4 className={'center'}>{t('homePage:noExpiredContracts')}</h4>
                </div>
            }
        </div>
    );
};